import { z } from 'zod';
import { MiceCorporatePathSchema, MiceNamedRefSchema, type MiceOrderStatus } from './mice';

/** Centro de custo do catálogo do cliente: `code` é o código legível (`null` = o catálogo não traz). */
export const MiceCostCenterRefSchema = MiceNamedRefSchema.extend({ code: z.string().nullable() });
export type MiceCostCenterRef = z.infer<typeof MiceCostCenterRefSchema>;

/** De onde veio o centro de custo do viajante: coluna `centro_custo` da planilha, troca do operador,
 *  premissas do evento ou o próprio viajante no convite. */
export const MiceTravelerCostCenterSourceSchema = z.enum([
  'sheet',
  'operator',
  'premises',
  'traveler',
]);
export type MiceTravelerCostCenterSource = z.infer<typeof MiceTravelerCostCenterSourceSchema>;

export const MiceTravelerCostCenterViewSchema = z.object({
  email: z.string(),
  costCenter: MiceNamedRefSchema,
  source: MiceTravelerCostCenterSourceSchema,
});
export type MiceTravelerCostCenterView = z.infer<typeof MiceTravelerCostCenterViewSchema>;

export const MiceTravelerCostCentersSchema = z.object({
  /** O das premissas do evento: vale para quem não está em `items`. */
  premises: MiceNamedRefSchema.nullable(),
  /** De onde vem o centro de custo de quem não está em `items` quando `premises` é nulo. Default: API anterior. */
  premisesPath: MiceCorporatePathSchema.default('event'),
  /** E-mails dos viajantes com compra em andamento ou emitida: o centro de custo deles não troca mais. */
  locked: z.array(z.string()),
  /** Só quem tem centro de custo próprio. */
  items: z.array(MiceTravelerCostCenterViewSchema),
});
export type MiceTravelerCostCenters = z.infer<typeof MiceTravelerCostCentersSchema>;

/** O que o seletor do operador oferece: a mesma lista com que a troca é conferida no servidor. */
export const MiceTravelerCostCenterOptionsSchema = z.object({
  costCenters: z.array(MiceNamedRefSchema),
});
export type MiceTravelerCostCenterOptions = z.infer<typeof MiceTravelerCostCenterOptionsSchema>;

export const MiceSetTravelerCostCenterRequestSchema = z.object({
  email: z.email(),
  costCenterId: z.string().min(1),
});
export type MiceSetTravelerCostCenterRequest = z.infer<
  typeof MiceSetTravelerCostCenterRequestSchema
>;

/** Status em que o pedido já comprou (ou está comprando): trocar o centro de custo não alcança mais a compra. */
export const MICE_COST_CENTER_LOCKED_STATUSES: readonly MiceOrderStatus[] = [
  'queued',
  'purchasing',
  'awaiting_approval',
  'awaiting_issuance',
  'issued',
  'indeterminate',
];
